import { DigitalMapPin } from 'models/digitalMap';
import styles from './PinCard.module.css';
import { StarredButton } from './StarredButton';

const getPinThumbnail = (pin: DigitalMapPin) => {
  return pin.media_items?.find((item) => item.type === 'IMAGE')?.url || '';
};

interface PinCardProps {
  pin: DigitalMapPin;
  isStarred: boolean;
  toggleStar: () => void;
}

export const PinCard = ({ pin, isStarred, toggleStar }: PinCardProps) => {
  return (
    <div className={styles.card} onClick={toggleStar}>
      <div className={styles.imageContainer}>
        {getPinThumbnail(pin) && (
          <img src={getPinThumbnail(pin)} alt={pin.title} className={styles.image} />
        )}
      </div>
      <h3 className={styles.title}>{pin.title}</h3>
      <div className={styles.starButtonContainer}>
        <StarredButton isStarred={isStarred} toggleStar={toggleStar} />
      </div>
    </div>
  );
};
